import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { YearlyComponent } from './yearly/yearly.component';
import { MonthlyComponent } from './monthly/monthly.component';
import { DashboardComponent } from './dashboard.component';
import { DashboardStatisticsComponent } from './dashboard-statistics/dashboard-statistics.component';
import { ContractorDashboardComponent } from './contractor-dashboard/contractor-dashboard.component';
import { GLOBAL } from '../app.globals';
import { AuthGuard } from '../auth.guard';

const routes: Routes = [
  {
    path: '',
    component: DashboardStatisticsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'dash-board',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'yearly',
    component: YearlyComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'monthly',
    component: MonthlyComponent,
    canActivate: [AuthGuard]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
